import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@mantine/core/styles.css';
import './index.css'
import App from './App.jsx'
import { MantineProvider, createTheme } from '@mantine/core';
import './i18n.js';

const theme = createTheme({
  colors: {
    dark: [
      '#C1C2C5',
      '#A6A7AB',
      '#909296',
      '#5c5f66',
      '#373A40',
      '#2C2E33',
      '#111111',
      '#000000',
      '#000000',
      '#000000',
    ],
  },
  components: {
    Card: {
      defaultProps: {
        bg: '#0a0a0a'
      }
    },
    Paper: {
      defaultProps: {
        bg: '#0a0a0a'
      }
    }
  }
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="dark">
      <App />
    </MantineProvider>
  </StrictMode>,
)
